import { HttpErrorResponse } from '@angular/common/http';

const GenericAPIErrorTitle = 'An error has occurred.';

export class BsError {
  constructor(err?: HttpErrorResponse, serviceName?: string) {
    if (err) {
      this.code = err?.status;
      if (err?.error?.title === GenericAPIErrorTitle) {
        this.title = `${serviceName} Error`;
      } else if (err?.error) {
        this.title = err?.error?.title;
      }
      this.message = err?.error?.message;
      this.suggestion = err?.error?.suggestion;
    }
  }

  public code: number;
  public title: string;
  public message: string;
  public suggestion: string;
}
